import { Card, CardBody, Button, Tooltip } from "@nextui-org/react";
import { FaCirclePlus } from "react-icons/fa6";
import { TbBuildingBroadcastTower } from "react-icons/tb";
const Acciones = ({handleChangeAccio}) => {
    return (
        <Card className="w-full px-9 py-4">
            
            <CardBody>
                <div className="flex items-center justify-center gap-4">
                    <Tooltip showArrow={true} content="Añadir usuario">
                        <Button color="warning" auto shadow className="p-3 text-lg min-w-fit rounded-full float-right" onClick={() => handleChangeAccio("add") }>
                            <FaCirclePlus />
                        </Button>
                    </Tooltip>
                    <Tooltip showArrow={true} content="Enviar una notificación general">
                        <Button color="warning" auto shadow className="p-3 text-lg min-w-fit rounded-full float-right">
                            <TbBuildingBroadcastTower />
                        </Button>
                    </Tooltip>
               

                </div>
            </CardBody>

        </Card>
    )
}
export default Acciones